import React from 'react';
import { CurricularClass8OpenDay2023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass8OpenDay2023 />;
};

export default ExtraCurricularActivitiesPage;